/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
/* eslint-disable jira/filename-case */
import type { Topic } from '@jira/servicedesk__knowledge-common/src/CategoryGuid.types.tsx';

type FetchSuggestedTopicsResponse = {
	topics: Topic[];
	isFiltered: boolean;
};

const APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

const getSuggestedTopicsUrl = (projectId: number, activationId: string) =>
	`${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics`;

export const fetchSuggestedTopics = (
	projectId: number,
	activationId: string,
): Promise<FetchSuggestedTopicsResponse> => {
	const url = getSuggestedTopicsUrl(projectId, activationId);
	return performGetRequest(url);
};
